<template>
    <div class="notification">
        <div class="icon">
            <img :src="warningImgSrc" alt="Warning" />
        </div>
        <div class="content">
            <h2>{{ title }}</h2>
            <p>{{ message }}</p>
        </div>
    </div>
</template>
  
<script>

import warningImg from '@/assets/warning.png';
export default {
    props: {
        title: String,
        message: String,
    },
    data() {
        return {
            warningImgSrc: warningImg
        }
    }
};
</script>
  
<style scoped>
.notification {
    display: flex;
    align-items: center;
    padding: 10px;
    border: 1px solid #bdbdbd;
    border-radius: 4px;
}

.icon {
    margin-right: 10px;
}

.icon img {
    width: 30px;
    height: 30px;
}

.content h2 {
    margin: 0;
    font-size: 16px;
}

.content p {
    margin: 5px 0 0;
    font-size: 14px;
}
</style>
  